import { render, staticRenderFns } from "./vast.vue?vue&type=template&id=1a39b1c0&"
import script from "./vast.vue?vue&type=script&lang=js&"
export * from "./vast.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports